/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react';

export const gridStyles = css`
  display: grid;
  grid-template-columns: 60% 35% 5%;
`;
